import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithMsal } from "./workinprogress.api";
export const baseApi = createApi({
    reducerPath: "api",
    baseQuery: baseQueryWithMsal,
    tagTypes: [
        "Projects",
        "Companies",
        "ProjectCostValues",
        "Roles",
        "CompanyMonthConfigs",
        "CostComponents",
    ],
    endpoints: () => ({}),
});
